const apiOrigin = () => {
  const configured = (process.env.REACT_APP_API_URL || 'http://localhost:5001').replace(/\/+$/, '');
  return configured.replace(/\/api$/i, '');
};

export const mediaUrl = (path) => {
  if (!path) return '';
  if (typeof path !== 'string') {
    if (path && typeof path.url === 'string') return mediaUrl(path.url);
    return '';
  }
  // The R2 S3 API host is not public. Serve those objects through /api/media.
  const s3 = path.match(/r2\.cloudflarestorage\.com\/(?:[^/?#]+\/)?(.+?)(?:[?#]|$)/i);
  if (s3) {
    return `${apiOrigin()}/api/media/${s3[1]}`;
  }
  if (/^(https?:|blob:|data:)/i.test(path)) return path;
  // Images bundled with the site are served by the site, not the API
  if (path.startsWith('/static/')) return path;
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${apiOrigin()}${clean}`;
};

export const mediaKey = (path) => {
  const url = mediaUrl(path);
  const at = url.indexOf('/api/media/');
  if (at === -1) return '';
  try {
    return decodeURIComponent(url.slice(at + '/api/media/'.length).split(/[?#]/)[0]);
  } catch (err) {
    return url.slice(at + '/api/media/'.length).split(/[?#]/)[0];
  }
};
